import { Polls } from "../../../../features/Polls";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const pollsRouteConfig: AppRouteProps = {
  path: appRouterPaths.polls.root,
  element: <Polls />,
  name: "Опросы",
};
